import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toastr } from "react-redux-toastr"

import { updateDesignRoomPosition } from '../../../../api/lt-api';

class DesignRoomPositionInput extends Component {
  static propTypes = {
    room: PropTypes.object.isRequired,
    rooms: PropTypes.array.isRequired,
    room_variant_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  state = {
    position: this.props.room.position || '',
    rooms: this.props.rooms,
    room_variant_id: this.props.room_variant_id,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.room.position !== this.props.room.position) {
      this.setState({ position: this.props.room.position || '' });
    }
  }

  handleChange = (event) => {
    const newPosition = event.target.value;
    this.setState({ position: newPosition });

    if (newPosition === '' || parseInt(newPosition, 10) >= 1) {
      this.updatePosition(newPosition);
    }
  };

  updatePosition = (query) => {
    const { room_variant_id, room } = this.props;
    const toasterSuccess = "Success, the design room position successfully updated";
    const toasterError = "Error, the design room position wasn't updated";

    if (query.length > 0 && !isNaN(parseInt(query, 10))) {
      updateDesignRoomPosition(room.design_room_id, room_variant_id, query)
        .then((response) => {
          if (response.warning !== undefined) {
            toastr.warning(response.warning);
          }else{
            toastr.success(toasterSuccess);
            window.location.reload();
          }
        })
        .catch((error) => {
          toastr.error(toasterError);
          this.setState({ position: this.props.room.position || '' });
        });
    }
  };

  render() {
    const { position } = this.state;
    const positions = this.state.rooms.map(room => room.position);
    const hasNullPosition = positions.some(p => p === null || p === undefined);
    const validPositions = positions.filter(p => p !== null && p !== undefined).sort((a, b) => a - b);
    const isConsecutive = !hasNullPosition && validPositions.length === this.state.rooms.length &&
      validPositions.every((p, i) => p === i + 1 && positions.indexOf(p) === i);

    const positionToIndex = {};
    if (!isConsecutive && !hasNullPosition) {
      positions.forEach((pos, idx) => {
        if (pos !== null && pos !== undefined) {
          positionToIndex[idx + 1] = pos;
        }
      });
    }

    const currentRoomIndex = this.state.rooms.findIndex(room => room.design_room_id === this.props.room.design_room_id);
    const selectValue = hasNullPosition ? '' : isConsecutive ? position : (currentRoomIndex >= 0 && positionToIndex[currentRoomIndex + 1] === position ? String(currentRoomIndex + 1) : '');

    return (
      <div className="position-input-wrapper" style={{ marginTop: '20px' }}>
        <p className="room-row-title" style={{ marginBottom: '10px' }}>Position</p>
        <select
          value={selectValue}
          onChange={this.handleChange}
          className="form-control position-input"
        >
          {hasNullPosition || !isConsecutive ? (
            Array.from({ length: this.state.rooms.length }, (_, i) => i + 1).map(p => (
              <option className="frontend" key={p} value={p}>
                {p}
              </option>
            ))
          ) : (
            this.state.rooms.map((room, idx) => (
              <option className="backend" key={room.design_room_id} value={room.position}>
                {room.position}
              </option>
            ))
          )}
        </select>
      </div>
    );
  }
}

export default DesignRoomPositionInput;
